export default __webpack_public_path__ + "static/media/carta_drop_01.791792ef.mp3";